import React from "react";

import {mr} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: (props: IIcon) => React.ReactElement;
    label: string;
}

export const ListingTypeTab = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div>
            <Icon size="2.4" css={mr(1)} /> {props.label}
        </div>
    );
};
import React from "react";

import {mr} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: (props: IIcon) => React.ReactElement;
    label: string;
}

export const ListingTypeTab = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div>
            <Icon size="2.4" css={mr(1)} /> {props.label}
        </div>
    );
};
